// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_textJustify__3YGFG {
  text-align: justify;
}

.styles_cameraContainer__QW4U1 {
  position: relative;
  height: 100%;
}

.styles_overlay__jdWzM {
  display: block;
  position: relative;
  margin-top: -63%;
  left: 7.5%;
  width: 85%;
  height: 80%;
  border: 2px dashed #cccccc;
  color: #ffffff;
  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.3), 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.styles_dContents__u8-My {
  display: contents !important;
}

.styles_input-otp__Ik5Zi {
  width: 140px;
  height: 42px;
  margin: 0;
  font-size: 18px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.styles_input-otp__Ik5Zi:focus {
  border: 1px solid #2356b3 !important;
  outline: none;
}

.styles_input-otp__Ik5Zi:focus-visible {
  border: 1px solid #2356b3 !important;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/sign-document/components/styles.module.scss"],"names":[],"mappings":"AAAA;EACG,mBAAA;AACH;;AAEA;EACE,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;EACA,4EAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,oCAAA;EACA,aAAA;AACF;;AAEA;EACE,oCAAA;EACA,aAAA;AACF","sourcesContent":[".textJustify {\n   text-align: justify;\n }\n\n.cameraContainer {\n  position: relative;\n  height: 100%;\n}\n\n.overlay {\n  display: block;\n  position: relative;\n  margin-top: -63%;\n  left: 7.5%;\n  width: 85%;\n  height: 80%;\n  border: 2px dashed #cccccc;\n  color: #ffffff;\n  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.3), 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n}\n\n.dContents {\n  display: contents !important;\n}\n\n.input-otp {\n  width: 140px;\n  height: 42px;\n  margin: 0;\n  font-size: 18px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.input-otp:focus {\n  border: 1px solid #2356b3 !important;\n  outline: none;\n}\n\n.input-otp:focus-visible {\n  border: 1px solid #2356b3 !important;\n  outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textJustify": `styles_textJustify__3YGFG`,
	"cameraContainer": `styles_cameraContainer__QW4U1`,
	"overlay": `styles_overlay__jdWzM`,
	"dContents": `styles_dContents__u8-My`,
	"input-otp": `styles_input-otp__Ik5Zi`
};
export default ___CSS_LOADER_EXPORT___;
